import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ScrollReveal } from "./components/Motion";
import { AuthProvider, useAuth, ROLE_HOME } from "./context/AuthContext";
import { RadioProvider } from "./context/RadioContext";
import AppShell, { RequireRole } from "./components/AppShell";
import PublicHub from "./pages/PublicHub";
import Home from "./pages/Home";
import Story from "./pages/Story";
import MuseumPage from "./pages/MuseumPage";
import Desk from "./pages/Desk";
import Circle from "./pages/Circle";
import Invite from "./pages/Invite";
import Organisation from "./pages/Organisation";
import Person from "./pages/Person";
import Entity from "./pages/Entity";
import Marketplace from "./pages/Marketplace";
import Careers from "./pages/Careers";
import Login from "./pages/Login";
import Ops from "./pages/Ops";
import HR from "./pages/HR";
import Executive from "./pages/Executive";
import Report from "./pages/Report";
import Narrative from "./pages/Narrative";
import Users from "./pages/Users";

const AppHome = () => {
  const { user } = useAuth();
  return <Navigate to={user ? ROLE_HOME[user.role] : "/login"} replace />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <RadioProvider>
        <BrowserRouter>
          <ScrollReveal />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/history" element={<Story page="history" />} />
            <Route path="/principals" element={<Story page="principals" />} />
            <Route path="/future" element={<Story page="future" />} />
            <Route path="/museum" element={<MuseumPage />} />
            <Route path="/entities/despite-automobile-museum" element={<Navigate to="/museum" replace />} />
            <Route path="/hub" element={<PublicHub />} />
            <Route path="/organisation" element={<Organisation />} />
            <Route path="/people/:slug" element={<Person />} />
            <Route path="/entities/:slug" element={<Entity />} />
            <Route path="/shop" element={<Marketplace />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/invite/:token" element={<Invite />} />
            <Route path="/login" element={<Login />} />
            <Route path="/app" element={<AppShell />}>
              <Route index element={<AppHome />} />
              <Route path="desk" element={<RequireRole roles={["partner", "secretary"]}><Desk /></RequireRole>} />
              <Route path="circle" element={<RequireRole roles={["partner", "secretary", "circle"]}><Circle /></RequireRole>} />
              <Route path="ops" element={<Ops />} />
              <Route path="hr" element={<RequireRole roles={["hr", "gm"]}><HR /></RequireRole>} />
              <Route path="exec" element={<RequireRole roles={["executive", "gm", "partner"]}><Executive /></RequireRole>} />
              <Route path="report" element={<RequireRole roles={["executive", "gm", "partner"]}><Report /></RequireRole>} />
              <Route path="narrative" element={<RequireRole roles={["executive", "gm", "partner"]}><Narrative /></RequireRole>} />
              <Route path="users" element={<RequireRole roles={["gm"]}><Users /></RequireRole>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </RadioProvider>
        <Toaster theme="light" position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
